import React, { useState, useEffect } from "react";
import { Table, Container, Input, Row, Col, Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import './ProposalStyle.css';
import "./Reports.css";
import pdfFonts from "pdfmake/build/vfs_fonts";
import pdfMake from "pdfmake/build/pdfmake";
import CreateTableComponent from "../../share/CreateTableComponent";
import { NumberWithCommmas2 } from "../../share/NumberWithCommmas2";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export function Report61Component() {

    const [thYearSelected, setThYearSelected] = React.useState(new Date().getFullYear() + 543)
    const [Re61data, setRe61data] = useState([]);
    const [Re61detail, setRe61detail] = useState([]);
    const [status, setStatus] = useState("0");
    const [openModalForm, setOpenModalForm] = useState(false);
    const [R61detailfilter, setR61detailfilter] = useState([]);

    pdfMake.fonts = {
        THSarabunNew: {
            normal: 'THSarabunNew.ttf',
            bold: 'THSarabunNew Bold.ttf',
            italics: 'THSarabunNew Italic.ttf',
            bolditalics: 'THSarabunNewn BoldItalic.ttf'
        },
        Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Medium.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-MediumItalic.ttf'
        }
    }





    async function getR61() {
        const formData = new FormData();
        formData.append("thYear", thYearSelected);
        const res61 = await fetch("/api/Support/getR61", {
            method: 'POST',
            body: formData
        })
        const Re61data = await res61.json()
        setRe61data(Re61data.dataenum);
        // console.log(Re61data)
    }

    const [Re61yeardata, setRe61yeardata] = React.useState([]);

    async function getR61year() {
        const res = await fetch("/api/Support/getyear61")
        const Re61yeardata = await res.json()
        setRe61yeardata(Re61yeardata.dataenum)
        console.log(Re61yeardata)
    }

    async function getR61detail(value, type) {
        const formData = new FormData();
        formData.append("thYear", thYearSelected);
        formData.append("status", String(type));
        // console.log("status",status);
        console.log("value", value);
        console.log("type", type);
        const res61 = await fetch("/api/Support/getR61detail", {
            method: 'POST',
            body: formData
        })
        const Re61data = await res61.json()
        // setRe61detail(Re61data.dataenum);
        setR61detailfilter(Re61data.dataenum.filter(
            (item) => item.supportDetail === value
        ))
        console.log(Re61data);
        modalToggleExtendCourse();
    }

    const modalToggleExtendCourse = () => {
        // getR61detail()
        setOpenModalForm(!openModalForm);
        // console.log("idmodal", value);
    }

    const COLUMNSTRAIN = [
        {
            Header: "ลำดับ",
            accessor: (_row, i) => i + 1,
        },
        {
            Header: "ชื่อผู้ได้รับเงินช่วยเหลือหรืออุดหนุน",
            accessor: "supportName",
        },
        {
            Header: "เลขที่คำขอ",
            accessor: "supportNo",
        },
        {
            Header: "จำนวนคน",
            accessor: "appPersonTotal",
            Cell: ({ value }) => {
                return (
                    <>
                        {NumberWithCommmas2(value)}

                    </>
                )

            }
        },
        {
            Header: "จำนวนเงินที่ขอรับช่วยเหลือหรืออุดหนุน (บาท)",
            accessor: "appAmount",
            Cell: ({ value }) => {
                return (
                    <>
                        {NumberWithCommmas2(value)}

                    </>
                )

            }
        },
        
    ]

    React.useEffect(() => {
        getR61()

        getR61year()
    }, [thYearSelected]);

    //let sumall1 = Re61data.reduce(function (prev, current) {
    //    return prev + +current.budget
    //}, 0);
    //let sumall2 = Re61data.reduce(function (prev, current) {
    //    return prev + +current.appCompanyTotal
    //}, 0);
    //let sumall3 = Re61data.reduce(function (prev, current) {
    //    return prev + +current.appPersonTotal
    //}, 0);
    //let sumall4 = Re61data.reduce(function (prev, current) {
    //    return prev + +current.appAmount
    //}, 0);
    //let sumall5 = Re61data.reduce(function (prev, current) {
    //    return prev + +current.total
    //}, 0);
    //let sumall6 = Re61data.reduce(function (prev, current) {
    //    return prev + +current.sum1
    //}, 0);
    //let sumall7 = Re61data.reduce(function (prev, current) {
    //    return prev + +current.sum2
    //}, 0);
    //let sumall8 = Re61data.reduce(function (prev, current) {
    //    return prev + +current.sum3
    //}, 0);
    //let sumall9 = Re61data.reduce(function (prev, current) {
    //    return prev + +current.sum4
    //}, 0);
    //let sumall10 = Re61data.reduce(function (prev, current) {
    //    return prev + +current.trnfCompanyTotal
    //}, 0);
    //let sumall11 = Re61data.reduce(function (prev, current) {
    //    return prev + +current.trnfPersonTotal
    //}, 0);
    //let sumall12 = Re61data.reduce(function (prev, current) {
    //    return prev + +current.trnfAmount
    //}, 0);
    //let sumall13 = Re61data.reduce(function (prev, current) {
    //    return prev + +current.ntrnfCompanyTotal
    //}, 0);
    //let sumall14 = Re61data.reduce(function (prev, current) {
    //    return prev + +current.ntrnfPersonTotal
    //}, 0);
    //let sumall15 = Re61data.reduce(function (prev, current) {
    //    return prev + +current.ntrnfAmount
    //}, 0);
    //let sumall16 = Re61data.reduce(function (prev, current) {
    //    return prev + +current.total1
    //}, 0);
    //let sumall17 = Re61data.reduce(function (prev, current) {
    //    return prev + +current.total2
    //}, 0);
    //let sumall18 = Re61data.reduce(function (prev, current) {
    //    return prev + +current.total3
    //}, 0);
    //let sumall19 = Re61data.reduce(function (prev, current) {
    //    return prev + +current.total4
    //}, 0);
    //let sumall20 = Re61data.reduce(function (prev, current) {
    //    return prev + +current.total5
    //}, 0);
    //let sumall21 = Re61data.reduce(function (prev, current) {
    //    return prev + +current.total6
    //}, 0);
    //let sumall22 = Re61data.reduce(function (prev, current) {
    //    return prev + +current.total7

    //}, 0);

    

    return (
        <Container>
            <div>

                <div style={{ display: 'flex', paddingBottom: '20px', justifyContent: 'center' }}>
                    <h3 className='text-center' style={{ lineHeight: 'inherit' }} >
                        ปีงบประมาณ พ.ศ.
                    </h3>
                    <Input
                        style={{ borderColor: "#130558", width: "10%", paddingTop: '0px', fontSize: '1.75rem' }}
                        id="othYear"
                        name="othYear"
                        type="select"
                        value={thYearSelected}
                        onChange={(e) => {
                            setThYearSelected(e.target.value)
                        }}
                    >
                        {Re61yeardata.map((item, i) => (
                            <option value={item.yearTh}>
                                {item.yearTh}
                            </option>
                        ))}
                    </Input>
                </div>
                <Row>
                    <Col className='d-flex justify-content-end'>
                        <Button className="btn1" href={`api/Support/xlsxR61?thYear=${thYearSelected}`} download>EXCEL</Button>
                        <Button className="btn2" href={`api/Support/pdfR61?thYear=${thYearSelected}`} download>PDF</Button>
                    </Col>
                </Row>
                <div className="outer-wrapper">
                    <div className="table-wrapper">
                        <Table className="styled-table" bordered striped hover>
                            <thead>
                                <tr>
                                    <th rowSpan="3">
                                        รายการ
                                    </th>
                                    <th rowSpan="3" className='text-center'>
                                        งบประมาณ
                                    </th>
                                    <th colSpan="3" className=' text-center'>
                                        อนุมัติจ่ายเงินอุดหนุนแล้ว (ต.ค.{thYearSelected - 1} - มี.ค.{thYearSelected})
                                    </th>
                                    <th rowSpan="3" className=' text-center'>
                                        คงเหลือ (บาท)
                                    </th>
                                    <th colSpan="3" className=' text-center'>
                                        อนุมัติ+โอนแล้วยังไม่จ่าย
                                    </th>
                                    <th rowSpan="3" className=' text-center'>
                                        คงเหลือ (บาท)
                                    </th>
                                    <th colSpan="9" className=' text-center'>
                                        ยังไม่จ่ายเงินช่วยเหลือหรืออุดหนุน
                                    </th>
                                    <th colSpan="2" className=' text-center'>
                                        รวม (เบิกจ่ายแล้ว+ยังไม่เบิกจ่าย)
                                    </th>
                                    <th rowSpan="3" className=' text-center'>
                                        รวม (เบิกจ่ายแล้ว+ยังไม่เบิกจ่าย)  (บาท)
                                    </th>
                                    <th rowSpan="3" className=' text-center' >
                                        งบประมาณคงเหลือ (บาท)
                                    </th>

                                </tr>
                                <tr>
                                    <th rowSpan="3" className='text-center'>
                                        (แห่ง)
                                    </th>
                                    <th rowSpan="3" className='text-center'>
                                        คน
                                    </th>
                                    <th rowSpan="3" className='text-center'>
                                        จำนวนเงิน (บาท)
                                    </th>
                                    <th rowSpan="3" className='text-center'>
                                        (แห่ง)
                                    </th>
                                    <th rowSpan="3" className='text-center'>
                                        คน
                                    </th>
                                    <th rowSpan="3" className='text-center'>
                                        จำนวนเงิน (บาท)
                                    </th>
                                    <th colSpan="3" className='text-center'>
                                        โอนแล้วยังไม่จ่าย
                                    </th>
                                    <th colSpan="3" className='text-center'>
                                        ยังไม่โอน
                                    </th>
                                    <th colSpan="3" className='text-center'>
                                        รวม
                                    </th>
                                    <th rowSpan="3" className='text-center'>
                                        (แห่ง)
                                    </th>
                                    <th rowSpan="3" className='text-center'>
                                        คน
                                    </th>

                                </tr>
                                <tr>

                                    <th className='text-center'>
                                        (แห่ง)
                                    </th>
                                    <th className='text-center'>
                                        คน
                                    </th>
                                    <th className='text-center'>
                                        จำนวนเงิน (บาท)
                                    </th>
                                    <th className='text-center'>
                                        (แห่ง)
                                    </th>
                                    <th className='text-center'>
                                        คน
                                    </th>
                                    <th className='text-center'>
                                        จำนวนเงิน (บาท)
                                    </th>
                                    <th className='text-center'>
                                        (แห่ง)
                                    </th>
                                    <th className='text-center'>
                                        คน
                                    </th>
                                    <th className='text-center'>
                                        จำนวนเงิน (บาท)
                                    </th>
                                </tr>

                            </thead>
                            <tbody>
                                {Re61data.length > 0 && Re61data.map((item, i) => (
                                    <tr >

                                        <td className='text-start'>
                                            {item.supportDetail}
                                        </td>

                                        <td className='text-center'>
                                            {item.budget}
                                        </td>

                                        {/* อนุมัติจ่ายเงินอุดหนุนแล้ว */}
                                        <td className='text-center'>
                                            {/* {item.appCompanyTotal} */}
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.supportDetail}
                                                onClick={(e) => {
                                                    // modalToggleExtendCourse(e.target.id); 
                                                    // setStatus("1");
                                                    getR61detail(e.target.id, "0")
                                                }}>{item.appCompanyTotal}</p>
                                        </td>
                                        <td className='text-center'>
                                            {item.appPersonTotal}
                                        </td>
                                        <td className='text-center'>
                                            {item.appAmount}
                                        </td>
                                        <td className='text-center'>
                                            {item.total}
                                        </td>

                                        {/* อนุมัติ โอนแล้วยังไม่จ่าย */}
                                        <td className='text-center'>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.supportDetail}
                                                onClick={(e) => {
                                                    getR61detail(e.target.id, "1")
                                                }}>{item.sum1}</p>
                                            {/* {item.sum1} */}
                                        </td>
                                        <td className='text-center'>
                                            {item.sum2} 
                                        </td>
                                        <td className='text-center'>
                                            {item.sum3}
                                        </td>
                                        <td className='text-center'>
                                            {item.sum4}
                                        </td>

                                        {/*โอนแล้วยังไม่จ่าย  */}
                                        <td className='text-center'>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.supportDetail}
                                                onClick={(e) => {
                                                    getR61detail(e.target.id, "2")
                                                }}>{item.ntrnfCompanyTotal}</p>
                                            {/* {item.trnfCompanyTotal} */}
                                        </td>
                                        <td className='text-center'>
                                            {item.ntrnfPersonTotal}
                                        </td>
                                        <td className='text-center'>
                                            {item.ntrnfAmount}
                                        </td>


                                        <td className='text-center'>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.supportDetail}
                                                onClick={(e) => {
                                                    getR61detail(e.target.id, "3")
                                                }}>{Number(item.nottrnfCompanytotal)}</p>

                                        </td>
                                        <td className='text-center'>
                                            {item.nottrnfPersonTotal}
                                        </td>
                                        <td className='text-center'>
                                            {item.nottrnfAmount} 
                                        </td>

                                        <td className='text-center'>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.supportDetail}
                                                onClick={(e) => {
                                                    getR61detail(e.target.id, "4")
                                                }}>{Number(item.total1)}</p>
                                            {/* {item.total1}  */}
                                        </td>
                                        <td className='text-center'>
                                            {item.total2} 
                                        </td>

                                        <td className='text-center'>
                                            {item.total3} 
                                        </td>
                                        
                                        <td className='text-center'>
                                            {item.total4} 4
                                        </td>
                                        <td className='text-center'>
                                            {item.total5} 5
                                        </td>
                                        <td className='text-center'>
                                            {item.total6} 6 
                                        </td>
                                        <td className='text-center'>
                                            {item.total7} 7
                                        </td>

                                    </tr>

                                )) || <tr><td colSpan="23" rowSpan="6" className='text-center'>No Data</td></tr>}

                                {/*<tr>*/}
                                {/*    <td colSpan="1" className='text-end'>*/}
                                {/*        รวม*/}
                                {/*    </td>*/}
                                {/*    <td className='text-center'>*/}
                                {/*        {sumall1}*/}
                                {/*    </td>*/}
                                {/*    <td className='text-center'>*/}
                                {/*        {sumall2}*/}
                                {/*    </td>*/}
                                {/*    <td className='text-center'>*/}
                                {/*        {sumall3}*/}
                                {/*    </td>*/}
                                {/*    <td className='text-center'>*/}
                                {/*        {sumall4}*/}
                                {/*    </td>*/}
                                {/*    <td className='text-center'>*/}
                                {/*        {sumall5}*/}
                                {/*    </td>*/}
                                {/*    <td className='text-center'>*/}
                                {/*        {sumall6}*/}
                                {/*    </td>*/}
                                {/*    <td className='text-center'>*/}
                                {/*        {sumall7}*/}
                                {/*    </td>*/}
                                {/*    <td className='text-center'>*/}
                                {/*        {sumall8}*/}
                                {/*    </td>*/}
                                {/*    <td className='text-center'>*/}
                                {/*        {sumall9}*/}
                                {/*    </td>*/}
                                {/*    <td className='text-center'>*/}
                                {/*        {sumall10}*/}
                                {/*    </td>*/}
                                {/*    <td className='text-center'>*/}
                                {/*        {sumall11}*/}
                                {/*    </td>*/}
                                {/*    <td className='text-center'>*/}
                                {/*        {sumall12}*/}
                                {/*    </td>*/}
                                {/*    <td className='text-center'>*/}
                                {/*        {sumall13}*/}
                                {/*    </td>*/}
                                {/*    <td className='text-center'>*/}
                                {/*        {sumall14}*/}
                                {/*    </td>*/}
                                {/*    <td className='text-center'>*/}
                                {/*        {sumall15}*/}
                                {/*    </td>*/}
                                {/*    <td className='text-center'>*/}
                                {/*        {sumall16}*/}
                                {/*    </td>*/}
                                {/*    <td className='text-center'>*/}
                                {/*        {sumall17}*/}
                                {/*    </td>*/}
                                {/*    <td className='text-center'>*/}
                                {/*        {sumall18}*/}
                                {/*    </td>*/}
                                {/*    <td className='text-center'>*/}
                                {/*        {sumall19}*/}
                                {/*    </td>*/}
                                {/*    <td className='text-center'>*/}
                                {/*        {sumall20}*/}
                                {/*    </td>*/}
                                {/*    <td className='text-center'>*/}
                                {/*        {sumall21}*/}
                                {/*    </td>*/}
                                {/*    <td className='text-center'>*/}
                                {/*        {sumall22}*/}
                                {/*    </td>*/}

                                {/*</tr>*/}
                            </tbody>


                        </Table>
                    </div>
                </div>
            </div>

            <Modal

                isOpen={openModalForm}
                toggle={modalToggleExtendCourse}
                // style={{ maxWidth: "600px", width: "100%" }}
                centered
                scrollable
                backdrop={'static'}
                keyboard={false}
                size="xl"

                className="modal-bordered"
            >
                <ModalHeader toggle={modalToggleExtendCourse} className="styled-modal text-center">
                    รายละเอียดข้อมูล
                </ModalHeader>
                <ModalBody >
                    <CreateTableComponent column={COLUMNSTRAIN} dataInput={R61detailfilter} showEntrie={true} showPage={true} />
                </ModalBody>
            </Modal>

        </Container>


    )
}